import { render, staticRenderFns } from "./apply-new-user.vue?vue&type=template&id=59b71652&"
import script from "./apply-new-user.vue?vue&type=script&lang=js&"
export * from "./apply-new-user.vue?vue&type=script&lang=js&"
import style0 from "./apply-new-user.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports